// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import clgEntity from './entities/clg.json';
import clgMenu from '../pages/clg/menu.json';
import clgFullForm from '../pages/clg/forms/full.json';
import clgContextForm from '../pages/clg/forms/context.json';
import clgMiniForm from '../pages/clg/forms/mini.json';
import clgLookupForm from '../pages/clg/forms/lookup.json';
import clgTableView from '../pages/clg/views/table.json';
import clgStagesView from '../pages/clg/views/stages.json';
import clgCardsView from '../pages/clg/views/cards.json';
import clgInlineView from '../pages/clg/views/inline.json';
import clgBacklogView from '../pages/clg/views/backlog.json';
import clgSplitView from '../pages/clg/views/split.json';
import clgCalendarView from '../pages/clg/views/calendar.json';
import clgDashboardView from '../pages/clg/views/dashboard.json';

/** Тип запису «Контакт» зі сторінками пакета: меню, форми та подання з pages/clg/. */
export const clgDefinition: IRecordTypeDefinition = {
  ...clgEntity,
  views: assembleViewSet({
      table: clgTableView,
      stages: clgStagesView,
      cards: clgCardsView,
      inline: clgInlineView,
      backlog: clgBacklogView,
      split: clgSplitView,
      calendar: clgCalendarView,
      dashboard: clgDashboardView,
  }),
  form: clgFullForm,
  forms: { full: clgFullForm, context: clgContextForm, mini: clgMiniForm, lookup: clgLookupForm },
  menu: clgMenu,
} as IRecordTypeDefinition;
